@if (isLoadingResults) {
  <div class="example-loading-shade">
    <mat-spinner [style.zoom]="1"></mat-spinner>
  </div>
}
<div
  cdkDrag
  class="popup_main_div add_report_main_eom add_top_clients"
  cdkDragRootElement=".cdk-overlay-pane"
>
  <h2 cdkDragHandle mat-dialog-title class="mat-dialog-header">
    @if (!isGenrateReport) {
      <span>Reports Generated</span>
    }
    @if (isGenrateReport) {
      <span>Generating Reports</span>
    }
    <button class="close-btn" mat-icon-button aria-label="Close dialog" [mat-dialog-close]="false">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <div mat-dialog-content class="mat-typography">
    @if (!isEndOfMonthData) {
      <div
        class="one iner-scroll-class gap-0!"
        fxLayout="column"
        fxLayoutAlign="start"
        fxLayout.gt-md="row"
        style="width: 100%"
      >
        @for (item of reportList; track item; let index = $index) {
          <div fxLayout="row" class="popup_body document_generated_main_div" style="width: 100%">
            @if (item.isGeenrate) {
              <div fxFlex="65" class="document_generated_main_first" fxLayoutAlign="start center">
                <div>The {{ item?.TITILE }} report has been produced.</div>
              </div>
            }
            @if (!item.isGeenrate) {
              <div
                fxFlex="50"
                class="document_generated_main_first"
                class="button"
                fxLayoutAlign="start center"
              >
                <div>Generating Report {{ item?.TITILE }}.</div>
              </div>
            }
            <!-- <div fxFlex="35" *ngIf="!item.isGeenrate" class="document_generated_main_last" class="button">
            <button mat-raised-button color="accent" [disabled]="item?.isButtonEnable" (click)="ReportGenerate(item.ID,reportDataDefult.ENDOFMONTHGUID,index)">
              Generate {{item?.TITILE}}
            </button>
          </div> -->
            @if (!item.isGeenrate) {
              <div fxFlex="50">
                @for (key of trackingData | keyvalue; track key; let i = $index) {
                  @if (item?.uniqueId == key?.value?.TRACKINGGUID) {
                    <div
                      class="popup_body document_generated_main_div cardbox"
                      style="width: 100%; margin-bottom: 15px"
                    >
                      <div style="position: relative; width: 100%">
                        <ng-container>
                          <mat-progress-bar
                            class="PGRESS"
                            [mode]="mode"
                            [value]="key.value.PROGRESS"
                          ></mat-progress-bar>
                        </ng-container>
                      </div>
                      <div style="width: 100%">
                        <h3>{{ key.value.DESCRIPTION }}</h3>
                      </div>
                    </div>
                  }
                }
              </div>
            }
            @if (item.isGeenrate) {
              <div
                fxFlex="35"
                class="document_generated_main_last button_eom_reports"
                fxLayoutAlign="start center"
              >
                <a
                  href="{{ item.URL }}"
                  target="_blank"
                  rel="noopener noreferrer"
                  mat-raised-button
                  color="accent"
                  class=""
                >
                  <mat-icon class="main-icon-show">
                    <img src="assets/icons/web_app/pdf.png" />
                  </mat-icon>
                </a>
              </div>
            }
          </div>
        }
        @if (isGenrateReport && isNewProgress == false) {
          <div class="popup_body document_generated_main_div" style="width: 100%; margin-top: 37px">
            <div style="position: relative; z-index: 99999; width: 100%">
              <h3>
                <strong>{{ title }}</strong>
                is being generated, please give it a moment.
              </h3>
              <br />
              <mat-progress-bar
                style="height: 2em"
                mode="determinate"
                [value]="progress"
              ></mat-progress-bar>
              <span
                style="position: absolute; top: 2.2em"
                [ngStyle]="{ left: progress + '%' }"
              ></span>
            </div>
          </div>
        }
        @if (isGenrateReport && isNewProgress == false) {
          <div class="popup_body document_generated_main_div" style="width: 100%">
            <div
              fxLayout="row"
              class="document_generated_main_first"
              fxLayoutAlign="start center"
              fxFlex="1 0 auto"
            >
              <h3>{{ btnText }}</h3>
            </div>
          </div>
        }
      </div>
    }

    <!-- <div class="one iner-scroll-class" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row" style="width: 100%;" *ngIf="isEndOfMonthData">
<div class="iner-scroll-class">
  <div fxLayout="row" *ngFor="let item of processEndOfMonthData; let index = index" class="popup_body document_generated_main_div" style="width: 100%;">
    <div fxFlex="55" *ngIf="item.isGeenrate" class="document_generated_main_first" fxLayoutAlign="start center">
      <div>The {{item?.SHORTDESC }} report has been produced.</div>
    </div>
    <div fxFlex="65" *ngIf="!item.isGeenrate" class="document_generated_main_first" class="button" fxLayoutAlign="start center">
      <div>Generating Report {{item?.SHORTDESC }}.</div>
    </div>
    <div fxFlex="35" *ngIf="!item.isGeenrate" class="document_generated_main_last" class="button">
      <button mat-raised-button color="accent" [disabled]="item?.isButtonEnable">
        Report Generating...
      </button>
    </div>
    <div fxFlex="45" *ngIf="item.isGeenrate" class="document_generated_main_last" fxLayoutAlign="start center" class="button">
      <a href="{{item?.URL}}" target="_blank">
        <button mat-raised-button color="accent">Click here to view it </button>
      </a>

      <button mat-raised-button color="accent" class="emailIt-btn"  (click)="GenerateEmail(item)">Click here to email it</button>
    </div>

  </div>
</div>
<div class="popup_body document_generated_main_div process_eom_data" *ngIf="isGenrateReport" style="width: 100%;margin-top: 37px;">
  <div style="position: relative;z-index: 99999;width: 100%;">
    <h3><strong>{{title}}</strong> is being generated, please give it a moment. </h3><br>
    <mat-progress-bar style="height: 2em;" mode="determinate" [value]="progress"></mat-progress-bar>
    <span style="position: absolute; top: 2.2em;" [ngStyle]="{'left': progress + '%'}"></span>
  </div>
</div>
<div class="popup_body document_generated_main_div" *ngIf="isGenrateReport" style="width: 100%;">
  <div fxLayout="row" class="document_generated_main_first" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <h3>{{btnText}}</h3>
  </div>
</div>
</div> -->
    @if (isEndOfMonthData) {
      <div
        class="one iner-scroll-class"
        fxLayout="column"
        fxLayoutAlign="start"
        fxLayout.gt-md="row"
        style="width: 100%"
      >
        <div style="position: relative; z-index: 99999; width: 100%">
          <h3>
            Your report request has been submitted. Keep a track of it in the Generated reports
            panel on the right.
          </h3>
          <br />
        </div>
      </div>
    }
  </div>
  <mat-dialog-actions class="popup_ftr justify-end!">
    @if (!isEndOfMonthData) {
      <button matButton="filled" [mat-dialog-close]="false" cdkFocusInitial>Cancel</button>
    }
    @if (isEndOfMonthData) {
      <button
        matButton="filled"
        [mat-dialog-close]="false"
        cdkFocusInitial
        [disabled]="isGenrateReport == true"
      >
        Ok
      </button>
    }
  </mat-dialog-actions>
</div>
